

import { lazy } from "react";
import BadgeIcon from "@mui/icons-material/Badge";

// import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import { Navigate } from "react-router-dom";

const EmployeeCreate = lazy(() => import("../components/employeeCreate"));
const EmployeeList = lazy(() => import("../components/employeeList"));
const EmployeeView = lazy(() => import("../components/employeeView"));

const employeeRoute = [
  {
    icon: BadgeIcon,
    name: "Employee Management",
    link: "employee",
    path: "employee",
    index: 20,
    superAdminView: false,
    element: <EmployeeList />,
    permission: "Employee-Read",
  },
  // children: [
  // {
  //   path: "employee",
  //   element: <EmployeeList />,
  //   name: "Employee",
  //   index: 4,
  //   link: "employee",
  //   icon: BadgeOutlinedIcon,
  // },
  {
    path: "employee/create",
    element: <EmployeeCreate />,
  },
  {
    path: "employee/:id",
    element: <EmployeeCreate />,
  },
  {
    path: "employee/view/:id",
    element: <EmployeeView />,
  },
  {
    path: "",
    element: <Navigate to="employee" replace />,
  },
  // ],
];
export default employeeRoute;
